import React, { useEffect, useState, useCallback } from 'react';
import { Heart } from 'lucide-react';

const KEY = 'impactgolf_wishlist';
const EVT = 'wishlist-change';

function readList() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

function writeList(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
}

export function useWishlist() {
  const [ids, setIds] = useState(readList);
  useEffect(() => {
    const sync = () => setIds(readList());
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  const toggle = useCallback((id) => {
    const list = readList();
    const next = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
    writeList(next);
  }, []);
  return { ids, toggle, has: (id) => ids.includes(id) };
}

/** A heart button. Toggles the product id in localStorage. */
export default function WishlistButton({ productId, className = '', size = 18 }) {
  const { has, toggle } = useWishlist();
  const active = has(productId);
  return (
    <button
      type="button"
      aria-label={active ? 'Remove from wishlist' : 'Add to wishlist'}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(productId);
      }}
      className={`inline-flex items-center justify-center rounded-full transition-all ${
        active
          ? 'bg-[#EF4444]/10 text-[#EF4444] hover:bg-[#EF4444]/20'
          : 'bg-white/90 text-gray-500 hover:text-[#EF4444] hover:bg-white'
      } ${className}`}
      data-testid={`wishlist-toggle-${productId}`}
    >
      <Heart
        size={size}
        className={active ? 'fill-current' : ''}
        strokeWidth={active ? 0 : 2}
      />
    </button>
  );
}
